const translation = {
  tags: {
    other: 'Інший',
    utilities: 'Утиліти',
    education: 'Освіта',
    social: 'Соціальний',
    videos: 'Відео',
    business: 'Бізнес',
    news: 'Вісті',
    design: 'Проект',
    search: 'Шукати',
    medical: 'Медичний',
    productivity: 'Продуктивність',
    finance: 'Фінанси',
    travel: 'Подорожувати',
    image: 'Образ',
    agent: 'Агент',
    weather: 'Погода',
    entertainment: 'Розваги',
  },
  allTags: 'Всі теги',
  searchTags: 'Пошукові теги',
}

export default translation
